(function() {
    'use strict';

    angular
        .module('gwApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider','$rootScopeProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('stockManagement', {
                parent: 'module',
                url: '/stock',
                data: {
                    authorities: ['ROLE_STOCK_TAKING_ORDER']
                },
                views: {
                    'content': {
                        templateUrl: 'app/stockManagement/stock.html',
                        controller: 'StockController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                        return $translate.refresh();
                    }]
                }
            })
            .state('stockAdd', {
                parent: 'module',
                url: '/stock/add?warehouseId',
                data: {
                    authorities: ['ROLE_STOCK_TAKING_ORDER']
                },
                views: {
                    'content': {
                        templateUrl: 'app/stockManagement/stock-edit.html',
                        controller: 'StockEditController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                        return $translate.refresh();
                    }],
                    entity: [function() {
                        return {}
                    }]
                }
            })
            .state('stockEdit', {
                parent: 'module',
                url: '/stock/edit/{id}',
                data: {
                    authorities: ['ROLE_STOCK_TAKING_ORDER']
                },
                views: {
                    'content': {
                        templateUrl: 'app/stockManagement/stock-edit.html',
                        controller: 'StockEditController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                        return $translate.refresh();
                    }],
                    entity: [function() {
                        return {}
                    }]
                }
            })
    }
})();
